<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item><i class="el-icon-lx-cascades"></i> {{$t('pages.globalSet.breadcrumb')}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="container" style="height: 1500px">
        <div class="divB">
            <el-form :inline="true" ref="mineNumberArr" :model="mineNumberArr">
                <el-card shadow="hover" style="height:210px; width: 1200px;">
                    <div>
                        <span>{{$t('pages.globalSet.homeColors.title')}}</span>
                    </div>
                    <el-card shadow="hover" style="height:70px;">
                        <div class="block">
                            <span class="demonstration">{{$t('pages.globalSet.homeColors.menuBg')}}</span>
                            <el-color-picker v-model="mineNumberArr.menuBarBackgroundColor" size="mini"></el-color-picker>
                            <span class="demonstration" style="margin-left:15px">{{$t('pages.globalSet.homeColors.homeBg')}}</span>
                            <el-color-picker v-model="mineNumberArr.homePageBackgroundColor" size="mini"></el-color-picker>
                            <span class="demonstration" style="margin-left:15px">{{$t('pages.globalSet.homeColors.titleColor')}}</span>
                            <el-color-picker v-model="mineNumberArr.titleColor" size="mini"></el-color-picker>
                            <span class="demonstration" style="margin-left:15px">{{$t('pages.globalSet.homeColors.textColor')}}</span>
                            <el-color-picker v-model="mineNumberArr.textColor" size="mini"></el-color-picker>
                            <span class="demonstration" style="margin-left:15px">{{$t('pages.globalSet.homeColors.button1')}}</span>
                            <el-color-picker v-model="mineNumberArr.buttonColor" size="mini"></el-color-picker>
                            <span class="demonstration" style="margin-left:15px">{{$t('pages.globalSet.homeColors.button2')}}</span>
                            <el-color-picker v-model="mineNumberArr.buttonColor2" size="mini"></el-color-picker>
                            <!-- <span class="demonstration" style="margin-left:15px">连接状态</span>
                            <el-color-picker v-model="connectionStatusColor" size="mini"></el-color-picker> -->
                        </div>
                    </el-card>
                    <el-button type="primary" @click="saveColors()" style="margin-top:-15px">{{$t('pages.globalSet.actions.save')}}</el-button>
                    <el-button type="primary" @click="restoreDefaultColors()" style="margin-top:-15px;margin-left:40px">{{$t('pages.globalSet.actions.restoreDefault')}}</el-button>
                </el-card>
                <el-card shadow="hover" style="height:65px; width:1200px;">

                    <!-- <el-form-item label="选择设备" prop="balanceId">
                        <el-select v-model="mineNumberArr.scalesName" placeholder="请选择" class="size-full" style="width:155px" ref="selectScales">
                            <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="煤矿编号:" style="margin-bottom:-200px">
                        <el-input v-model="mineNumberArr.mineNumber" placeholder="煤矿编号" style="width:100px"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="saveEdit('MineNumber')">确 定</el-button>
                    </el-form-item> -->

                    <el-form-item :label="$t('pages.globalSet.db14.mainSwitch')">
                        <el-switch v-model="isUseDB14" :active-text="$t('pages.globalSet.switch.open')" :inactive-text="$t('pages.globalSet.switch.close')" @change="changeDB14()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item :label="$t('pages.globalSet.zfw.label')" style="margin-bottom:-30;margin-left:30px;">
                        <el-switch v-model="isUseZFW" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeZFW()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item :label="$t('pages.globalSet.dtjk.label')" style="margin-bottom:-30;margin-left:30px;">
                        <el-switch v-model="isDTJKMY0002S" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeDTJKMY0002S()" style="margin-top:5px" />
                    </el-form-item>
                </el-card>
                <el-card shadow="hover" style="height:65px;width:1200px;">
                    <el-form-item :label="$t('pages.globalSet.snjson.label')" style="margin-bottom:-30px">
                        <el-switch v-model="isUseSNJson" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeSNJson()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item style="margin-left:30px;margin-bottom:-200px">
                        <el-input v-model="mineNumberArr.snJsonRefreshRate" style="width:60px"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('pages.globalSet.snjson.secondsSuffix')">
                        <el-button type="primary" @click="saveSeconds('snJsonRefreshRate')">{{$t('pages.globalSet.actions.confirm')}}</el-button>
                    </el-form-item>
                </el-card>
                <el-card shadow="hover" style="height:65px;width:1200px;">
                    <el-form-item :label="$t('pages.globalSet.report.label')" style="margin-bottom:-30px">
                        <el-switch v-model="isReportGeneration" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeReportGeneration()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item style="margin-left:30px;margin-bottom:-200px" :label="$t('pages.globalSet.report.everyDay')">
                        <el-select v-model="mineNumberArr.reportGenerationTime" class="size-full" style="width:80px">
                            <el-option v-for="item in ReportGenerationTime" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('pages.globalSet.report.oClock')">
                        <el-button type="primary" @click="saveTime('reportGenerationTime')">{{$t('pages.globalSet.actions.confirm')}}</el-button>
                    </el-form-item>
                </el-card>
                <el-card shadow="hover" style="height:60px;width:1200px;">
                    <el-form-item :label="$t('pages.globalSet.display.cnb')" style="margin-bottom:10px">
                        <el-switch v-model="isDisplayCNB" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeCNB()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item :label="$t('pages.globalSet.display.device')" style="margin-bottom:-30;margin-left:20px;">
                        <el-switch v-model="isDisplayDevice" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeDeviceStatus()" style="margin-top:5px" />
                    </el-form-item>
                    <!-- <el-form-item label="显示实时流量曲线:" style="margin-bottom:-30;margin-left:20px;">
                        <el-switch v-model="isFlowCurve" active-text="是" inactive-text="否" @change="changeFlowCurveStatus()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item label="显示实时产量柱形图:" style="margin-bottom:-30;margin-left:20px;">
                        <el-switch v-model="isColumnChart" active-text="是" inactive-text="否" @change="changeColumnChartStatus()" style="margin-top:5px" />
                    </el-form-item> -->
                </el-card>
                <el-card shadow="hover" style="height:60px;width:1200px;">
                    <el-form-item :label="$t('pages.globalSet.motor.label')" style="margin-bottom:-30px">
                        <el-switch v-model="isUseMotor" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeMotor()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item :label="$t('pages.globalSet.messageCenter.label')" style="margin-bottom:-30px;margin-left:30px;">
                        <el-switch v-model="isMessageCenter" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeMessageCenter()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item :label="$t('pages.globalSet.companyName.label')" style="margin-bottom:-30px;margin-left:30px;">
                        <el-switch v-model="isDisplayCompanyName" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeDisplayCompanyName()" style="margin-top:5px" />
                    </el-form-item>
                </el-card>
                <el-card shadow="hover" style="height:65px;width:1200px;">
                    <el-form-item :label="$t('pages.globalSet.virtual.totalSwitch')" style="margin-bottom:-30px">
                        <el-switch v-model="isVirtual" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeVirtual()" style="margin-top:5px" />
                    </el-form-item>
                    <el-form-item :label="$t('pages.globalSet.virtual.scaleNameLabel')" style="margin-bottom:-200px;margin-left: 30px;">
                        <el-input v-model="mineNumberArr.virtualname" :placeholder="$t('pages.globalSet.virtual.scaleNamePlaceholder')" style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item style="margin-left:20px">
                        <el-button type="primary" @click="saveEdit('MineNumber')">{{$t('pages.globalSet.actions.confirm')}}</el-button>
                    </el-form-item>
                </el-card>
                <el-card shadow="hover" style="height:60px;width:1200px;">
                    <el-form-item :label="$t('pages.globalSet.multithreading.label')" style="margin-bottom:-30px">
                        <el-switch v-model="isMultithreading" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeMultithreading()" style="margin-top:5px" />
                    </el-form-item>
                </el-card>
                <el-card shadow="hover" style="height:350px;width:1200px;">
                    <div>
                        <span>{{$t('pages.globalSet.coalPlatform.title')}}</span>
                    </div>
                    <el-card shadow="hover" style="height:65px;">
                        <el-form-item :label="$t('pages.globalSet.coalPlatform.mineName')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.minename" :placeholder="$t('pages.globalSet.coalPlatform.mineNamePh')" style="width:280px"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.coalPlatform.mineCode')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.minecode" :placeholder="$t('pages.globalSet.coalPlatform.mineCodePh')" style="width:120px"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.coalPlatform.uploadScale')">
                            <el-select v-model="mineNumberArr.scalesId" :placeholder="$t('pages.globalSet.coalPlatform.selectPlaceholder')" style="width:120px" ref="selectScales">
                                <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-card>
                    <el-card shadow="hover" style="height:65px;">
                        <el-form-item :label="$t('pages.globalSet.coalPlatform.serverIP')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.ip" :placeholder="$t('pages.globalSet.coalPlatform.serverIPPh')" style="width:100px"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.coalPlatform.port')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.port" :placeholder="$t('pages.globalSet.coalPlatform.portPh')" style="width:60px"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.coalPlatform.account')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.username" :placeholder="$t('pages.globalSet.coalPlatform.accountPh')" style="width:80px"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.coalPlatform.password')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.password" :placeholder="$t('pages.globalSet.coalPlatform.passwordPh')" style="width:90px"></el-input>
                        </el-form-item>
                        <el-form-item style="margin-left:20px">
                            <el-button type="primary" @click="saveEdit('MineNumber')">{{$t('pages.globalSet.actions.confirm')}}</el-button>
                        </el-form-item>
                    </el-card>
                    <el-card shadow="hover" style="height:65px;width:1200px;">
                        <el-form-item :label="$t('pages.globalSet.coalPlatform.dataUpload')" style="margin-left:3px">
                            <el-switch v-model="isUseCoalInforUpload" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeCoalInfoSupervision()" style="margin-top:5px" />
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.coalPlatform.receivePound')" style="margin-left:3px">
                            <el-switch v-model="isReceivePoundData" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeReceivePoundData()" style="margin-top:5px" />
                        </el-form-item>
                        <el-form-item style="margin-left:60px">
                            <el-button type="primary" @click="UpLog('MineNumber')">{{$t('pages.globalSet.actions.uploadQuery')}}</el-button>
                        </el-form-item>
                    </el-card>
                </el-card>
                <el-card shadow="hover" style="height:250px;width:1200px;">
                    <div>
                        <span>{{$t('pages.globalSet.cloud.title')}}</span>
                    </div>
                    <el-card shadow="hover" style="height:45px;">
                        <el-form-item :label="$t('pages.globalSet.cloud.serverIP')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.cloudip" :placeholder="$t('pages.globalSet.cloud.serverIPPh')" style="width:100px"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.cloud.port')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.cloudport" :placeholder="$t('pages.globalSet.cloud.portPh')" style="width:60px"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.cloud.clientId')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.cloudid" :placeholder="$t('pages.globalSet.cloud.clientIdPh')" style="width:80px"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.cloud.account')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.cloudusername" :placeholder="$t('pages.globalSet.cloud.accountPh')" style="width:80px"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('pages.globalSet.cloud.password')" style="margin-bottom:-200px">
                            <el-input v-model="mineNumberArr.cloudpassword" :placeholder="$t('pages.globalSet.cloud.passwordPh')" style="width:90px"></el-input>
                        </el-form-item>
                    </el-card>
                    <el-card shadow="hover" style="height:65px;">
                        <el-form-item :label="$t('pages.globalSet.cloud.uploadSwitch')" style="margin-left:3px;margin-bottom:-200px">
                            <el-switch v-model="isCloudUpload" :active-text="$t('pages.globalSet.switch.yes')" :inactive-text="$t('pages.globalSet.switch.no')" @change="changeCloudUpload()" style="margin-top:5px" />
                        </el-form-item>
                        <el-form-item style="margin-left:30px">
                            <el-button type="primary" @click="saveEdit('MineNumber')">{{$t('pages.globalSet.actions.confirm')}}</el-button>
                        </el-form-item>
                    </el-card>
                </el-card>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import router from '../../router';
export default {
    name: 'mineNumberArr',
    data() {
        return {
            mineNumberArr: {
                mineNumber: '666666',
                scalesName: '',
                scalesId: '',
                snJsonRefreshRate: '60',
                name: '',
                id: '',
                isdb14file: '0',
                iszfwfile: '0',
                issnjsonfile: '0',
                iscnb: 0,
                isdisplaydevicestatus: 0,
                ismotor: 0,
                ip: '',
                iscoalinforupload: 0,
                isUseReportGeneration: false,
                reportGenerationTime: 16,
                password: '',
                port: '',
                username: '',
                minename: '',
                minecode: '',
                threadStartupType: 0,
                menuBarBackgroundColor: '#999',
                homePageBackgroundColor: '#999',
                titleColor: '#999',
                textColor: '#999',
                buttonColor: '#999',
                buttonColor2: '#999',
                cloudip: '',
                cloudport: '0',
                cloudid: '',
                cloudusername: '',
                cloudpassword: '',
                iscloudupload: false,
                isflowcurve: false,
                iscolumnchart: false,
                isreceivepounddata: false,
                virtualname: '',
                isdtjkmy0002s: false
            },
            isReportGeneration: true,
            isUseDB14: true,
            isUseZFW: true,
            isUseSNJson: true,
            isDisplayCNB: true,
            isDisplayDevice: true,
            isUseMotor: true,
            isMessageCenter: true,
            isDisplayCompanyName: true,
            isMultithreading: true,
            isUseCoalInforUpload: true,
            isReceivePoundData: true,
            isCloudUpload: true,
            isFlowCurve: true,
            isColumnChart: true,
            isVirtual: false,
            isDTJKMY0002S: false,
            balanceArr: [],
            ReportGenerationTime: [{
                name: '0点',
                value: 0
            }, {
                name: '1',
                value: 1
            }, {
                name: '2',
                value: 2
            }, {
                name: '3',
                value: 3
            }, {
                name: '4',
                value: 4
            }, {
                name: '5',
                value: 5
            }, {
                name: '6',
                value: 6
            }, {
                name: '7',
                value: 7
            }, {
                name: '8',
                value: 8
            }, {
                name: '9',
                value: 9
            }, {
                name: '10',
                value: 10
            }, {
                name: '11',
                value: 11
            }, {
                name: '12',
                value: 12
            }, {
                name: '13',
                value: 13
            }, {
                name: '14',
                value: 14
            }, {
                name: '15',
                value: 15
            }, {
                name: '16',
                value: 16
            }, {
                name: '17',
                value: 17
            }, {
                name: '18',
                value: 18
            }, {
                name: '19',
                value: 19
            }, {
                name: '20',
                value: 20
            }, {
                name: '21',
                value: 21
            }, {
                name: '22',
                value: 22
            }, {
                name: '23',
                value: 23
            }, ],
        };
    },
    created() {
        this.getSystemInfo();
        this.getBalances();
    },
    methods: {
        getSystemInfo() {
            var serach = {};
            this.$zybhttp
                .get('Business/GetSystemInfo', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data;
                        this.version = d.msg;
                        this.mineNumberArr.mineNumber = d.data.list[0].mineNumber;
                        this.mineNumberArr.snJsonRefreshRate = d.data.list[0].snJsonRefreshRate;
                        this.mineNumberArr.id = d.data.list[0].id;
                        this.mineNumberArr.name = d.data.list[0].name;
                        this.mineNumberArr.scalesName = d.data.list[0].scalesName;
                        this.mineNumberArr.scalesId = d.data.list[0].scalesId;
                        this.mineNumberArr.isdb14file = d.data.list[0].isDB14File;
                        this.mineNumberArr.iszfwfile = d.data.list[0].isZFWFile;
                        this.mineNumberArr.issnjsonfile = d.data.list[0].isSNJsonFile;
                        this.mineNumberArr.iscnb = d.data.list[0].isCNB;
                        this.mineNumberArr.isdisplaydevicestatus = d.data.list[0].isDisplayDeviceStatus;
                        this.mineNumberArr.ismotor = d.data.list[0].isMotor;
                        this.mineNumberArr.threadStartupType = d.data.list[0].threadStartupType;
                        this.mineNumberArr.iscoalinforupload = d.data.list[0].isCoalInforUpload;
                        this.mineNumberArr.ip = d.data.list[0].ip;
                        this.mineNumberArr.port = d.data.list[0].port;
                        this.mineNumberArr.username = d.data.list[0].userName;
                        this.mineNumberArr.password = d.data.list[0].passWord;
                        this.mineNumberArr.minename = d.data.list[0].mineName;
                        this.mineNumberArr.minecode = d.data.list[0].mineCode;
                        this.mineNumberArr.reportGenerationTime = d.data.list[0].reportGenerationTime;
                        this.mineNumberArr.menuBarBackgroundColor = d.data.list[0].menuBarBackgroundColor;
                        this.mineNumberArr.homePageBackgroundColor = d.data.list[0].homePageBackgroundColor;
                        this.mineNumberArr.titleColor = d.data.list[0].titleColor;
                        this.mineNumberArr.textColor = d.data.list[0].textColor;
                        this.mineNumberArr.buttonColor = d.data.list[0].buttonColor;
                        this.mineNumberArr.buttonColor2 = d.data.list[0].buttonColor2;
                        this.mineNumberArr.cloudip = d.data.list[0].cloudIP;
                        this.mineNumberArr.cloudport = d.data.list[0].cloudPort;
                        this.mineNumberArr.cloudid = d.data.list[0].cloudID;
                        this.mineNumberArr.cloudusername = d.data.list[0].cloudUserName;
                        this.mineNumberArr.cloudpassword = d.data.list[0].cloudPassWord;
                        this.mineNumberArr.iscloudupload = d.data.list[0].isCloudUpload;
                        this.mineNumberArr.isflowcurve = d.data.list[0].isFlowCurve;
                        this.mineNumberArr.iscolumnchart = d.data.list[0].isColumnChart;
                        this.mineNumberArr.isreceivepounddata = d.data.list[0].isReceivePoundData;
                        this.mineNumberArr.ismessagecenter = d.data.list[0].isMessageCenter;
                        this.mineNumberArr.isdisplaycompanyname = d.data.list[0].isDisplayCompanyName;
                        this.mineNumberArr.isvirtual = d.data.list[0].isVirtual;
                        this.mineNumberArr.virtualname = d.data.list[0].virtualName;
                        this.mineNumberArr.isdtjkmy0002s = d.data.list[0].isDTJKMY0002S;
                        this.isUseDB14 = d.data.list[0].isDB14File == 1 ? true : false;
                        this.isUseZFW = d.data.list[0].isZFWFile == 1 ? true : false;
                        this.isUseSNJson = d.data.list[0].isSNJsonFile == 1 ? true : false;
                        this.isDisplayCNB = d.data.list[0].isCNB == 1 ? true : false;
                        this.isDisplayDevice = d.data.list[0].isDisplayDeviceStatus == 1 ? true : false;
                        this.isUseMotor = d.data.list[0].isMotor == 1 ? true : false;
                        this.isUseCoalInforUpload = d.data.list[0].isCoalInforUpload == 1 ? true : false;
                        this.isReportGeneration = d.data.list[0].isUseReportGeneration == true ? true : false;
                        this.isMultithreading = d.data.list[0].threadStartupType == 1 ? true : false;
                        this.isCloudUpload = d.data.list[0].isCloudUpload == 1 ? true : false;
                        this.isFlowCurve = d.data.list[0].isFlowCurve == 1 ? true : false;
                        this.isColumnChart = d.data.list[0].isColumnChart == 1 ? true : false;
                        this.isReceivePoundData = d.data.list[0].isReceivePoundData == 1 ? true : false;
                        this.isMessageCenter = d.data.list[0].isMessageCenter == 1 ? true : false;
                        this.isDisplayCompanyName = d.data.list[0].isDisplayCompanyName == 1 ? true : false;
                        this.isVirtual = d.data.list[0].isVirtual == 1 ? true : false;
                        this.isDTJKMY0002S = d.data.list[0].isDTJKMY0002S == 1 ? true : false;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkListError')));
        },
        saveEdit() {
            this.$refs['mineNumberArr'].validate((valid) => {
                this.mineNumberArr.scalesName = this.$refs.selectScales.selectedLabel;
                if (valid) {
                    this.$zybhttp
                        .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('common.modifySuccess'));
                                this.getSystemInfo();
                            } else {
                                this.$notify.error(this.$t('common.modifyFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        saveSeconds() {
            this.$refs['mineNumberArr'].validate((valid) => {
                if (valid) {
                    this.$zybhttp
                        .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                        .then((res) => {
                            const r = /^\+?[1-9][0-9]*$/;
                            if (!r.test(this.mineNumberArr.snJsonRefreshRate)) {
                                this.$alert(this.$t('common.inputPositiveInt'));
                                return;
                            };
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('common.modifySuccess'));
                                this.getSystemInfo();
                            } else {
                                this.$notify.error(this.$t('common.modifyFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        saveTime() {
            this.mineNumberArr.isUseReportGeneration = this.isReportGeneration;
            this.$refs['mineNumberArr'].validate((valid) => {
                if (valid) {
                    this.$zybhttp
                        .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('common.modifySuccess'));
                                this.getSystemInfo();
                            } else {
                                this.$notify.error(this.$t('common.modifyFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        changeDB14() {
            this.mineNumberArr.isdb14file = this.isUseDB14 ? '1' : '0';
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeZFW() {
            this.mineNumberArr.iszfwfile = this.isUseZFW ? '1' : '0';
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeDTJKMY0002S() {
            this.mineNumberArr.isdtjkmy0002s = this.isDTJKMY0002S ? true : false;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeSNJson() {
            this.mineNumberArr.issnjsonfile = this.isUseSNJson ? '1' : '0';
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeVirtual() {
            this.mineNumberArr.isvirtual = this.isVirtual ? true : false;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeReportGeneration() {
            this.mineNumberArr.isUseReportGeneration = this.isReportGeneration ? true : false;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeCNB() {
            this.mineNumberArr.iscnb = this.isDisplayCNB ? 1 : 0;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeDeviceStatus() {
            this.mineNumberArr.isdisplaydevicestatus = this.isDisplayDevice ? 1 : 0;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeMotor() {
            this.mineNumberArr.ismotor = this.isUseMotor ? 1 : 0;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeMessageCenter() {
            this.mineNumberArr.ismessagecenter = this.isMessageCenter ? true : false;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeDisplayCompanyName() {
            this.mineNumberArr.isdisplaycompanyname = this.isDisplayCompanyName ? true : false;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('common.modifySuccess'));
                        this.getSystemInfo();
                    } else {
                        this.$notify.error(this.$t('common.modifyFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkModifyError')));
        },
        changeMultithreading() {
            this.mineNumberArr.threadStartupType = this.isMultithreading ? 1 : 0;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getSystemInfo();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        changeCoalInfoSupervision() {
            this.mineNumberArr.iscoalinforupload = this.isUseCoalInforUpload ? 1 : 0;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getSystemInfo();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        changeReceivePoundData() {
            this.mineNumberArr.isreceivepounddata = this.isReceivePoundData ? true : false;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getSystemInfo();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        changeCloudUpload() {
            this.mineNumberArr.iscloudupload = this.isCloudUpload ? true : false;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getSystemInfo();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        changeFlowCurveStatus() {
            this.mineNumberArr.isflowcurve = this.isFlowCurve ? true : false;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getSystemInfo();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        changeColumnChartStatus() {
            this.mineNumberArr.iscolumnchart = this.isColumnChart ? true : false;
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getSystemInfo();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        getBalances() {
            this.$zybhttp
                .get('Balance/GetBalance', {
                    params: {
                        balanceId: ''
                    }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        var tem_arr = [];
                        for (let i = 0; i < d.length; i++) {
                            if (d[i].balanceType == 1) {
                                tem_arr[i] = d[i];
                            }
                        }
                        this.balanceArr = tem_arr;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkListError')));
        },
        UpLog() {
            this.$router.push('CoalInforUploadRecord')
        },
        restoreDefaultColors() {
            this.mineNumberArr.menuBarBackgroundColor = '#324157';
            this.mineNumberArr.homePageBackgroundColor = '#324157';
            this.mineNumberArr.titleColor = '#e8f4ff';
            this.mineNumberArr.textColor = '#ffffff';
            this.mineNumberArr.buttonColor = '#324157';
            this.mineNumberArr.buttonColor2 = '#576a86';
            this.mineNumberArr.connectionStatusColor = '#914';
        },
        saveColors() {
            this.$zybhttp
                .post('SystemInfo/SetSystemInfo', this.mineNumberArr)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getSystemInfo();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
    }
};
</script>

<style scoped>
.divA {
    float: left;
    width: 30%;
    /* border: 1px solid #fbacce; */
}

.divB {
    float: left;
    width: 48%;
    /* border: 1px solid #fbacce; */
    margin-left: 30px;
}

.divB div,
h3 {
    margin-bottom: 30px;
}

.size-full {
    width: 100%;
}
</style>
